<template>
  <div>
    <v-snackbar top right v-model="snackbar" :color="snackbar_color" :timeout="1000" >
      <span>{{snackbar_message}}</span>
    </v-snackbar>     
    <v-row v-if="loading" class="pb-3 pt-3px-3">
        <v-col class="text-center">
          <v-progress-linear
            color="info"
            height="5"
            indeterminate
            striped
          ></v-progress-linear>
        </v-col>
    </v-row>
    <v-row v-else class="pl-4 pb-2 mt-1">
       <v-col cols="12" md="9" transition="scale-transition">
        <v-row>
          <v-col cols="12" md="3">
            <v-card class="neu-glow px-4 pb-4">
              <v-card-title>
                iReview 
                <v-spacer></v-spacer>
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn v-bind="attrs" v-on="on" icon fab small class="neu-glow mr-2" @click="dialog_settings=true">
                        <v-icon color="info">mdi-cogs</v-icon>
                      </v-btn>
                    </template>
                    <span>Impostazioni</span>
                  </v-tooltip> 
                            
              </v-card-title>
              <v-card-text>
              <v-row>

                <v-col cols="12" class="text-center">
                  <v-btn-toggle
                    v-model="selectedItem"
                    mandatory
                    active-class="info"
                    style="flex-direction: column"
                  >
                    <v-btn
                      
                      :value="c"
                      v-for="(c,ci) in prizes"
                      :key="ci">
                      {{c.title}}
                    </v-btn>
                  </v-btn-toggle>              
                </v-col>
              <v-row>
                </v-card-text> 
            </v-card>
          </v-col>
          <v-col cols="12" md="9">
            <v-card class="neu-glow px-4 pb-4">
              <v-card-title>
                Coupon 
                <v-spacer></v-spacer>
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn v-bind="attrs" v-on="on" icon fab small class="neu-glow mr-4" :disabled="JSON.stringify(selectedItem)==prize_hash||selectedItem.class=='noCoupon'" :loading="loading_update" @click="saveItem()">
                        <v-icon color="error">mdi-content-save</v-icon>
                      </v-btn>
                    </template>
                    <span>Salva Modifiche</span>
                  </v-tooltip>
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn v-bind="attrs" v-on="on" icon fab small class="neu-glow mr-2" @click="dialog_instruction=true">
                        <v-icon color="info">mdi-help-circle</v-icon>
                      </v-btn>
                    </template>
                    <span>Istruzioni</span>
                  </v-tooltip>                           
              </v-card-title>
              <v-card-text> 
                <v-row>
                <template v-if="selectedItem&&selectedItem.class!=='noCoupon'">
                  <v-col cols="12" md="12" class="text-center">
                    <div class="pa-2">
                      <div class="text-left pb-2">Giorni validi</div>
                      <v-btn-toggle v-model="selectedItem.validDoW" multiple small active-class="info" class="d-inline-block transparent">
                        <v-btn 
                          small
                          v-for="(d,di) in dows" :key="di" :value="d.code">
                          {{d['it'].substring(0,2).toUpperCase()}}
                        </v-btn>
                      </v-btn-toggle>
                    </div>
                  </v-col>
                  <v-col cols="12" :md="selectedItem.class=='conditionalCoupon'?6:12">
                    <div>Giorni durata Coupon</div>
                    <v-slider
                      class="mt-12"
                      color="info"
                      max=30
                      min=3
                      step=1
                      thumb-label="always"
                      ticks="always"
                      label=""
                      hide-details
                      v-model="selectedItem.duration"
                    >        
                    </v-slider>                               
                  </v-col> 
                  <v-col cols="12" md="6" v-if="selectedItem.class=='conditionalCoupon'">
                    <div>Score Minimo per coupon</div>
                    <v-slider
                      class="mt-12"
                      color="info"
                      max=20
                      min=1
                      step=1
                      thumb-label="always"
                      ticks="always"
                      label=""
                      hide-details
                      v-model="selectedItem.minimumScore"
                    >        
                    </v-slider>
                  </v-col>                         
                  <v-col cols="12" md="6">
                    <v-text-field
                      class="mt-6"            
                      counter
                      label="Nome Premio"
                      outlined
                      v-model="selectedItem.highRewardName"
                      hide-details
                    >
                    </v-text-field>
                    <v-textarea
                      class="mt-6"            
                      counter
                      label="Descrizione Premio"
                      outlined
                      v-model="selectedItem.highRewardDescription"
                      hide-details
                    >
                    </v-textarea>                   
                  </v-col> 
                  <!--
                  <v-col cols="12" md="6">
                    <v-textarea
                      class="mt-6"            
                      counter
                      label="Descrizione Premio"
                      outlined
                      v-model="selectedItem.highRewardDescription"
                      hide-details
                    >
                    </v-textarea>   
                  </v-col>
                  -->                        
                  <v-col cols="10" md="5">
                    <div class="mb-5">Immagine</div>
                    <v-img v-if="selectedItem.highRewardImage" 
                      :src="'/static/users/pictures/coupons/'+selectedItem.highRewardImage||'/static/users/pictures/coupons/default.png'"
                      :lazy-src="'/static/users/pictures/coupons/'+selectedItem.highRewardImage||'/static/users/pictures/coupons/default.png'"
                      max-width="200"
                      class="mx-auto"
                    ></v-img>              
                  </v-col>
                  <v-col cols="2" md="1">
                    <v-tooltip top>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn v-bind="attrs" v-on="on" icon fab small class="neu-glow mr-2" :id="'pick-coupon'" @click="openCropper()" >
                          <v-icon color="info">mdi-image-edit</v-icon>
                        </v-btn>
                      </template>
                      <span>Cambia Immagine</span>
                    </v-tooltip>                         
                  </v-col>
                </template> 
              </v-row>
              </v-card-text>
            </v-card>            
          </v-col>
        </v-row>
       </v-col>
       <v-col cols="12" md="3">
        <v-row>
          <v-col>
        <v-card class="neu-glow px-4 pb-4">
          <!--
          <v-card-title>
            Cosa vede il Cliente
            <v-spacer></v-spacer>       
          </v-card-title>
          -->
          <v-card-text class="text-h6 py-3">Dopo aver rilasciato un feedback con Score pari a...</v-card-text>
          <v-card-text class="pa-0">
              <v-slider
                class="mt-12"
                color="info"
                max=20
                min=1
                step=1
                thumb-label="always"
                ticks="always"
                label=""
                hide-details
                v-model="sumReviews"
              >        
              </v-slider>                
          </v-card-text>
          <v-card-text class="text-h6 py-3">il cliente visualizza quanto segue:</v-card-text>          
          <v-card-text>
            <v-card class="pa-4  neu-glow">
              <div>
                {{$t('Review.Thanks for your time')}},
                <p>{{$t('Review.Your opinion is very important to us since it help us every day to improve')}}</p>
                <div class="text-center">
                  <v-icon color="red" style="font-size:140px">mdi-heart</v-icon>
                </div>
                <!--
                <template v-else> 
                  <div>{{$t('Review.We are happy to inform that we have reserved you a free coupon to be used within')}}
                    <div class="font-weight-bold text-center">
                      {{' ' + addDaysFormatted(selectedItem.duration)}}
                    </div>
                    <span v-if="selectedItem.validDoW"> {{$t('Review.on')}} {{dows.filter(d=>selectedItem.validDoW.includes(d.code)).map(r=>r[settings.locale]).join(', ')}} </span>
                    {{$t('Review.for')}}
                  </div>
                  <p class="text-center font-weight-bold">{{selectedItem.highRewardName}}</p>
                  <v-img v-if="selectedItem.highRewardImage" 
                    :src="'/static/users/pictures/coupons/'+selectedItem.highRewardImage||'/static/users/pictures/coupon/default.png'"
                    :lazy-src="'/static/users/pictures/coupons/'+selectedItem.highRewardImage||'/static/users/pictures/coupon/default.png'"
                    max-width="200"
                    class="mx-auto"
                  ></v-img>
                  <p v-if="selectedItem.highRewardDescription" class="mt-2">{{selectedItem.highRewardDescription}}</p>
                  <p class="mt-2">{{$t('Review.At your arrival, remember to show the QRCode to the waiter')}}</p>
                  <div class="text-center">
                    <qrcode-vue :value="QRCodeLink" :size="150" level="L"></qrcode-vue>
                  </div>
                  <p class="text-center mt-2">{{$t('Review.For your convenience, we just sent you a WhatsApp message with the QR Code')}}</p>
                </template>
                -->
              </div>
            </v-card>            
          </v-card-text>
          <v-card-text>
            <v-card class="pa-4  neu-glow" v-if="(selectedItem.class=='noCoupon'&&sumReviews>=Math.max(...this.prizes.map(o => o.minimumScore)))||(sumReviews>=selectedItem.minimumScore&&selectedItem.class=='conditionalCoupon'||selectedItem.class=='yesCoupon')">
              <div>
                <template v-if="selectedItem.class=='noCoupon'&&sumReviews>=Math.max(...this.prizes.map(o => o.minimumScore))">
                  <p>{{$t('Review.Please share your review loading it on Tripadvisor')}}:</p>
                  <p>{{$t('Review.To proceed, click the button')}}.</p>
                  <div class="text-center">
                    <v-btn color="#00aa6c">
                      <v-icon class="mr-3">fa fa-tripadvisor</v-icon>
                      Tripadvisor
                    </v-btn>
                  </div>                  
                </template>
                <template v-if="sumReviews>=selectedItem.minimumScore&&selectedItem.class=='conditionalCoupon'||selectedItem.class=='yesCoupon'">
                  <p>A breve ti invieremo su whatsApp un coupon omaggio...</p>
                </template>
                <template v-if="sumReviews>=selectedItem.minimumScore&&selectedItem.class!=='noCoupon'">
                  <p>{{$t('Review.Meanwhile, please share your review loading it on Tripadvisor')}}:</p>
                  <!--
                  <p>{{$t('Review.Your review has already been copied into the clipboard: you have just to paste it')}}</p>
                  <p>{{$t('Review.We add a token at the end of your review for tracking purposes, pls do not remove it')}}</p>
                  -->
                  <p>{{$t('Review.To proceed, click the button')}}.</p>
                  <div class="text-center">
                    <v-btn color="#00aa6c">
                      <v-icon class="mr-3">fa fa-tripadvisor</v-icon>
                      Tripadvisor
                    </v-btn>
                  </div>
              </template>
            </v-card>
          </v-card-text>
        </v-card>
          </v-col>
        </v-row>
       </v-col>       
    </v-row>


    <v-dialog v-model="dialog_settings" max-width="800">
      <v-card>
        <v-card-title class="text-h5 mb-3">
          Impostazioni Invii Automatizzati
          <v-spacer></v-spacer>
          <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
              <v-btn v-bind="attrs" v-on="on" icon fab small class="neu-glow mr-2"  @click="dialog_settings = false">
                  <v-icon color="info">mdi-close</v-icon>
              </v-btn>
              </template>
              <span>Esci</span>
          </v-tooltip> 
        </v-card-title>
        <v-card-text>
          <v-row>
      <v-col cols="12" lg="12" v-if="allMeals">
        <v-card class="neu-glow">
          <v-card-title class="text-h5 mb-3 blue-grey darken-1">
            Impostazioni invii Automatizzati
          </v-card-title>                
          <v-tabs
            class="blue-grey"
            v-model="dowId"
            next-icon="mdi-arrow-right-bold-box-outline"
            prev-icon="mdi-arrow-left-bold-box-outline"
            show-arrows
          >
            <v-tabs-slider color="info"></v-tabs-slider>
            <template v-for="(d,di) in dows2" >
              <v-tab
                :key=di
                value="d"
                :href="'#'+d"
                class="font-weight-bold"
              >
                {{d}}
              </v-tab>
              <v-tab-item :key=d :id="d" class="mb-1 neu-glow">

                <v-row class="my-n2 pl-5">
                  <v-col cols="12">
                    <v-sheet class="neu-glow">
                      <v-tabs
                        class="grey lighten-5 neu-glow"
                        v-model="mealId"
                        next-icon="mdi-arrow-right-bold-box-outline"
                        prev-icon="mdi-arrow-left-bold-box-outline"
                        show-arrows
                      >
                        <v-tabs-slider color="info"></v-tabs-slider>
                        <template v-for="(m,mi) in allMeals" >
                          <v-tab
                            :key=mi
                            :href="'#'+m.mealId"
                            class="font-weight-bold mr-3 neu-glow"
                            
                          >
                            {{m.name}} 
                          </v-tab>
                          <v-tab-item :key=m :id="m.mealId" class="my-3 pl-5 mr-3 neu-glow mt-2" >
                              <v-row>
                                <v-col cols="2" style="max-width:100px">
                                  Slot
                                </v-col>
                                <v-col v-for="(hh,hi) in headers" :key="hi">
                                  <v-tooltip top>
                                    <template v-slot:activator="{ on, attrs }">
                                      <div v-bind="attrs" v-on="on" class="text-center">
                                        {{hh.title}}
                                      </div>
                                    </template>
                                    <span v-html="hh.remarks"></span>
                                  </v-tooltip>
                                </v-col>
                              </v-row>
                              <template v-for="(s,si) in activeSlots.filter(s => s.DOW==di+1&&s.mealId==m.mealId)">
                                <v-row :key="si" class="px-3" >
                                  <v-col cols="2" style="max-width:100px;min-width:100px" class="text-center">
                                    <v-text-field
                                      label=""
                                      v-model="s.slotName"
                                      name="slot"
                                      outlined
                                      readonly
                                      dense
                                      reverse
                                      hide-details="false"
                                    ></v-text-field>
                                  </v-col>
                                  <v-col class="d-flex justify-center">
                                    <v-checkbox
                                      class="mt-0 pt-2"
                                      dense
                                      v-model="s.reviewRequest"
                                      :id="s.slotId"
                                      @click="save2(s.reviewRequest,'reviewRequest','PBD',s.slotId,$event)"
                                      label=""
                                      hide-details
                                    ></v-checkbox> 
                                  </v-col>
                                  <!--   
                                  <v-col class="d-flex justify-center">
                                    <v-checkbox
                                      class="mt-0 pt-2"
                                      dense
                                      v-model="s.manualConfirmation"
                                      :id="s.slotId"
                                      @click="save2(s.manualConfirmation,'manualConfirmation','PBD',s.slotId,$event)"
                                      label=""
                                      hide-details
                                    ></v-checkbox>
                                  </v-col>
                                  -->
                                  
                                </v-row>
                              </template>
                          </v-tab-item>
                        </template>
                      </v-tabs>
                    </v-sheet>
                  </v-col>
                </v-row>
              </v-tab-item>
            </template>
          </v-tabs>
        </v-card>              
      </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!--
    <v-dialog v-model="dialog_imageChange_info" max-width="400">
        <v-card>
            <v-card-title class="text-h5 mb-3">
              Suggerimenti
              <v-spacer></v-spacer>
              <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                  <v-btn v-bind="attrs" v-on="on" icon fab small class="neu-glow mr-2"  @click="dialog_imageChange_info = false">
                      <v-icon color="info">mdi-close</v-icon>
                  </v-btn>
                  </template>
                  <span>Esci</span>
              </v-tooltip> 
            </v-card-title>
            <v-divider></v-divider>
            <v-row class="mx-5 mt-1">
                <v-col md="12" cols="12">
                    <p>
                        Si consiglia di ritagliare una immagine quadrata, possibilmente senza sfondo
                    </p>
                </v-col>
            </v-row>
        </v-card>
    </v-dialog>
    -->
    <v-dialog v-model="dialog_instruction" max-width="800">
        <v-card class="neu-glow pa-4">
            <v-card-title class="text-h5 mb-3">
              Istruzioni
              <v-spacer></v-spacer>
              <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                  <v-btn v-bind="attrs" v-on="on" icon fab small class="neu-glow mr-2"  @click="dialog_instruction = false">
                      <v-icon color="info">mdi-close</v-icon>
                  </v-btn>
                  </template>
                  <span>Esci</span>
              </v-tooltip> 
            </v-card-title>
            <v-divider></v-divider>
            <v-card class="neu-glow pa-4">
              <v-row class="mx-5 mt-1">            
                <v-col md="3" cols="6">
                  Abilita Premio
                </v-col>
                <v-col md="9" cols="6">
                  Abilita o disabilita il premio indipendentemente dai parametri successivi
                </v-col>
                <v-col md="3" cols="6">
                  Giorni Validi
                </v-col>
                <v-col md="9" cols="6">
                  Giorni della settimana validi per spendere il premio.
                  <br>Cambiate il valore e verificate cosa cambia in "Cosa vede il Cliente"
                </v-col>
                <v-col md="3" cols="6">
                  Durata
                </v-col>
                <v-col md="9" cols="6">
                  Giorni entro i quali il premio può essere riscosso
                  <br>Cambiate il valore e verificate cosa cambia in "Cosa vede il Cliente"
                </v-col>
                <v-col md="3" cols="6">
                  Minimo per Google/TA
                </v-col>
                <v-col md="9" cols="6">
                  Somma minima delle stelle ottenute nella valutazione interna (escluso Location) per richiedere la recensione su Google o TripAdvisor
                </v-col>
                <v-col md="3" cols="6">
                  Intervallo Premio
                </v-col>
                <v-col md="9" cols="6">
                  Intervallo della somma di stelle ottenute nella valutazione interna (escluso Location) per offrire il Coupon
                </v-col>
              <v-col md="3" cols="6">
                  Nome Premio
                </v-col>
                <v-col md="9" cols="6">
                  Nome del premio che verrà visualizzato dal Cliente
                  <br><span class="red--text">Specificare la quantità: esempio 1 Bottiglia, oppure 1 Calice <strong>ciascuno</strong></span>
                </v-col>
                <v-col md="3" cols="6">
                  Descrizione del Premio
                </v-col>
                <v-col md="9" cols="6">
                  Descrizione Libera del premio (facoltativa)
                </v-col> 
                <v-col md="3" cols="6">
                  Immagine Premio
                </v-col>
                <v-col md="9" cols="6">
                  Immagine coordinata del premio: si consiglia di ritagliare una immagine quadrata, la dimensione viene automaticamente ridotta a 600x600px
                </v-col>                            
            </v-row>
          </v-card>
        </v-card>
    </v-dialog>
    <v-dialog v-model="dialog_delete" max-width="400px">
        <v-card>
            <v-card-title class="text-h6">
              Confermi Cancellazione?
              <v-spacer></v-spacer>
              <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                  <v-btn v-bind="attrs" v-on="on" icon fab small class="neu-glow mr-2" :loading="loading_update"  @click="saveItem('delete')">
                      <v-icon color="error">mdi-delete</v-icon>
                  </v-btn>
                  </template>
                  <span>Si, Confermo</span>
              </v-tooltip>   

              <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                  <v-btn v-bind="attrs" v-on="on" icon fab small class="neu-glow mr-2"  @click="dialog_delete=false">
                      <v-icon color="info">mdi-close</v-icon>
                  </v-btn>
                  </template>
                  <span>No, Esci</span>
              </v-tooltip>              
            </v-card-title>
            <v-divider></v-divider>
        </v-card>
    </v-dialog>
    <v-dialog v-model="dialog_newItem" max-width="600px" v-if="selectedItem">
        <v-card class="neu-glow">
            <v-card-title class="text-h6">
              Nuovo Coupon
              <v-spacer></v-spacer>
              <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                  <v-btn v-bind="attrs" v-on="on" icon fab small class="neu-glow mr-4" :disabled="!selectedItem.newPrizeName" :loading="loading_update"  @click="saveItem('new')">
                      <v-icon color="info">mdi-content-save</v-icon>
                  </v-btn>
                  </template>
                  <span>Salva</span>
              </v-tooltip>   

              <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                  <v-btn v-bind="attrs" v-on="on" icon fab small class="neu-glow mr-2"  @click="dialog_newItem=false">
                      <v-icon color="info">mdi-close</v-icon>
                  </v-btn>
                  </template>
                  <span>Annulla</span>
              </v-tooltip>              
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text class="mt-3">
              <div>Inserisci nome Nuovo Coupon</div>
              <v-text-field
                class="mt-6"            
                counter
                label="Nome Coupon"
                outlined
                v-model="selectedItem.newPrizeName"
                hide-details
              >
              </v-text-field>   
            </v-card-text>
        </v-card>
    </v-dialog>
    <v-dialog v-model="dialog_vuecropper" max-width="1100" v-if="UFD">
      <vuecropper 
        @close="closeCropper"
        @completed="handleCompleted"
        @error="handlerError"
        :uploadFormData="UFD"
      >
      </vuecropper>
    </v-dialog>	    
  </div>
</template>
<script>
import { mapGetters } from "vuex";
//import _ from 'lodash'
import vuecropper from "../VueCropper";
import QrcodeVue from 'qrcode.vue';
export default {
   components: {
      QrcodeVue,
      vuecropper
    },  
  data() {
    return {
      page: "Settings",
      loading:false,
      loading_update:false,
      dialog_instruction:false,
      dialog_vuecropper:false,
      dialog_edit:false,
      dialog_delete:false,
      dialog_imageChange_info:false,
      dialog_newItem:false,
      dialog_settings:false,
      wHeight: window.innerHeight,
      wWidth: window.innerWidth,
      snackbar:null,
      snackbar_color:null,
      snackbar_message:null,
      allLocations:null,
      clockStep:null,
      activeSlots:null,
      activeSlots_hash:null,
      tabs:[],
      mealId:null,
      tabId:null,
      dowId:null,
      slotId:null,
      brand:null,
      subdomain:null,   
      UFD:null,   
      QRCodeLink:'BB560C31F20E418C0A5E2955ECD88FEFED082D42',
      review:{"food":4,"service":4,"value":4,"location":4,"review":null},
      editedItem:{text:"",value:null,sortOrder:null,icon:"",active:false},
      emptyItem:{text:"",value:null,sortOrder:null,icon:"",active:false},
      dows2:['LUN','MAR','MER','GIO','VEN','SAB','DOM'],
      headers:[
              //{title:"Invio Promemoria",remarks:"Invio Promemoria (solo se Invio Promemoria è attivo nella finestra sopra)"},
              {title:"Invio Richesta Review",remarks:"Invio Richesta Review (solo se Invio Richiesta Review è attivo nella finestra sopra)"},
              /*        
              {title:"Max Coperti",remarks:"Max Coperti accettabili in quello slot"},
              {title:"Max da 1",remarks:"Max Prenotazioni da 1 Coperto"},
              {title:"Max da 2",remarks:"Max Prenotazioni da 2 Coperto"},
              {title:"Max da 3",remarks:"Max Prenotazioni da 3 Coperto"},
              {title:"Durata Pasto",remarks:"Durata Pranzo in Minuti<br>Ovvero entro quanto deve essere lasciato libero il tavolo"},
              {title:"Blocca Prec",remarks:"Non accetta prenotazioni su questo slot fino a quando lo slot precedente non ha almeno la percentuale di completezza indicata"},
              {title:"Blocca Succ",remarks:"Non accetta prenotazioni su questo slot fino a quando lo slot successivo non ha almeno la percentuale di completezza indicata"},
              {title:"Cauzione",remarks:"Cauzione richiesta (per ogni coperto) per confermare la prenotazione"},
              {title:"Chiusura DB",remarks:"Non accetta prenotazioni da Direct Booking (per lo stesso giorno) oltre l'ora indicata"},
              {title:"Rich FBack",remarks:"Invia richiesta di feedback su queste prenotazioni"}
              */
              ], 
      
      dows:[
            {code:1,it:'Lunedì',en:'Mondays'},
            {code:2,it:'Martedì',en:'Tuesdays'},
            {code:3,it:'Mercoledì',en:'Wednsdays'},
            {code:4,it:'Giovedì',en:'Thursdays'},
            {code:5,it:'Venerdì',en:'Fridays'},
            {code:6,it:'Sabato',en:'Saturdays'},
            {code:7,it:'Domenica',en:'Sundays'}
           ],
      headersPromo:[
              {title:"Omaggio",remarks:"Omaggio (per persona) offerto"},
              ],
      headers2: [
                { text: 'Nome',         value: 'prizeName',   align: 'start',   sortable: false, class:'px-1 text-lg-button' },
                { text: 'Auto',         value: 'auto',      align: 'center',  sortable: false, class:'pl-1 text-lg-button' },
                //{ text: 'Coupon',       value: 'prizeEnabled',    align: 'center',  sortable: false, class:'pl-1 text-lg-button' },
                { text: 'Score>',   value: 'minimumScore',    align: 'center',  sortable: false, class:'pl-1 text-lg-button' },
                { text: 'Azione',       value: 'actions',     align: 'center',  sortable: false, class:'pl-1 text-lg-button' },
              ],              
      allMeals:null,
      selectedItem:null,
      sumReviews:16,
      uploadURL:'https://ibookrestaurant.com/ajax/settings/upload.php',
      coupons:[{"class":"noCoupon","txt":"Senza Coupon"},{"class":"conditionlCoupon","txt":"Coupon Condizionato"},{"class":"yesCoupon","txt":"Sempre Coupon"}],
      cropperOptions:[
                      {dragMode: 'move',autoCropArea: 0.8,viewMode: 1,movable: true,zoomable: true,center: true,highlight: true,cropBoxMovable: true,cropBoxResizable: true},
                      {aspectRatio: 4, dragMode: 'move',autoCropArea: 0.8,viewMode: 1,movable: true,zoomable: true,center: true,highlight: true,cropBoxMovable: true,cropBoxResizable: true}
                     ],
      outputOptions: [
                        {
                        width: 600,
                        height: 600,
                        minWidth: 300,
                        minHeight: 300,
                        maxWidth: 900,
                        maxHeight: 900,
                        imageSmoothingEnabled: true,
                        imageSmoothingQuality: 'high',
                      }
                    ],      
      pictureName:null,
      pictureNameW:null,
      pictureNameRoot:null,
      pictureNameRootW:null,
      prize_hash:null, 
    };
  },
  computed : {
    ...mapGetters(["settings"]),   
  },
  beforeUnmount()
  {
      //alert("leaving")
  },
  created(){
    this.getData();
    this.getData2();
  },
  mounted(){
    //console.log(768,this.$route.query.user)
  },
  watch : {
    selectedItem(newVal,oldVal)
    {
      console.log(695,newVal,oldVal)
      if (newVal.class=='noCoupon')
      {
        this.save2(newVal.class, 'reviewCouponClass', 'User_Options','')
      }
    }
    /*
    'selectedItem.highRewardRange':function (newVal,oldVal){
      console.log(559,newVal,oldVal,this.review)
      this.calcPrize()
    },
    'selectedItem.lowRewardRange':function (newVal,oldVal){
      console.log(559,newVal,oldVal,this.review)
      this.calcPrize()
    },
    'review.food':function (newVal,oldVal){
      console.log(559,newVal,oldVal,this.review)
      this.calcPrize()
    },
    'review.service':function (newVal,oldVal){
      console.log(559,newVal,oldVal,this.review)
      this.calcPrize()
    },
    'review.value':function (newVal,oldVal){
      console.log(559,newVal,oldVal,this.review)
      this.calcPrize()
    },    
    item (newValue) {
      console.log(289,newValue)
      //this.getData(newValue)
    }*/
  },
  methods:
  {
    save2(value, field, table,slotId='') {
      console.log(410,value, field,this.dowId);
      var pload;     
      if (table=='PBD')
      {
        var dow=this.dows2.findIndex(d=>d==this.dowId)+1
        pload={"parameter":field,"value":value===false?0:value===true?1:value===''?null:value,"slotId":slotId,"dow":dow};
        console.log(411,pload);
        table='AllParametersByDOW_single'
      }
      else
      {
        pload={"optionId":field,"value":value===false?0:value===true?1:value===''?null:value};
      }
      
      //pload[field]=value;
      var action='saveItem';
      let payload={"action":action,"table":table,"payload":pload};
      console.log(413,payload)
      let rspns=this.updateDB(payload)
      console.log(rspns)

    },
    openCropper()
    {
      this.UFD={'pictureName':this.selectedItem.highRewardImage,'type':'coupons','optionId':'coupon','width':400,'height':400}
      console.log(701,this.UFD)
      this.dialog_vuecropper=true;
    },
    closeCropper()
    {
      this.dialog_vuecropper=false;
      this.UFD=null;
    }, 
    showFileChooser() {
      this.$refs.camera.click();
    },
    handleUploading({ form, request }) {
      // show a loader
      console.log(384, {form, request})
    },
    handleCompleted({ response,form1 } )
    {
      console.log(388, response,response.data)
      //console.log(185, form1)
      this[form1.name]=response.payload;
      if (response.status=='OK')
      {
        this.changedLogo=true;
        this.snackbar_color='success';
        this.snackbar_message='Modificata Immagine';
        this.selectedItem.reviewImage=response.pictureName;
        this.selectedItem.highRewardImage=response.pictureName;
        console.log(654,this.selectedItem.reviewImage)
      }
      else
      {
        this.snackbar_color='error';
        this.snackbar_message=response.message;
      }
      this.snackbar=true;
    },
    handleError({ message, type, context}) {
      if (type === 'upload') {
        const { request, response } = context
      console.log(409, message, request, response)
      this.snackbar=true;
      this.snackbar_color='error';
      this.snackbar_message=response.message;      
      }
    },    
    setPictureName(i)
    {
      console.log(648,i);
      //this.pictureType=i.optionId.includes('TB')?'tb':'db';
      this.pictureNameRoot='';
      this.optionId='';
      this.pictureName='';
    },
   addDaysFormatted(days) {
     var result = new Date();
     result.setDate(result.getDate() + days);
     return result.toLocaleDateString( this.settings.locale,{ weekday: 'long',  month: 'long', day: 'numeric' });
   },/*
   calcPrize()
   {
      const review2={...this.review};
      delete review2.location;
      const sumReviews = Object.values(review2).reduce((a, b) => a + b, 0);
      this.sumReviews=sumReviews;
      const hrr=this.selectedItem.highRewardRange;
      const lrr=this.selectedItem.lowRewardRange;
      console.log(653,hrr,lrr,sumReviews)
      if(sumReviews>=hrr[0]&&sumReviews<=hrr[1])
      {
        console.log(656)
        this.selectedItem.hasPrize=true
        this.selectedItem.reviewPrize=this.selectedItem.highRewardName;
        this.selectedItem.reviewDescription=this.selectedItem.highRewardDescription;
        this.selectedItem.reviewImage=this.selectedItem.highRewardImage;
      }
      else if (sumReviews>=lrr[0]&&sumReviews<=lrr[1])
      {
        console.log(663)
        this.selectedItem.hasPrize=true
        this.selectedItem.reviewPrize=this.selectedItem.lowRewardName;
        this.selectedItem.reviewDescription=this.selectedItem.lowRewardDescription;
        this.selectedItem.reviewImage=this.selectedItem.lowRewardImage;
      }
      else
      {
        console.log(670)
        this.selectedItem.hasPrize=false
        this.selectedItem.reviewPrize=null;
        this.selectedItem.reviewDescription=null;
        this.selectedItem.reviewImage=null;
      }
   },*/
   /*
   save: _.debounce(function (event) {
      //this.refreshItem(event.target.name,event.target.value)
      console.log(296,event);
      console.log(297,event.target.name,event.target.value,event.target.id)
      console.log(298,this.dowId,this.mealId,this.activeSlots)
      //console.log(299,this.VMOptions[event.target.name])

      var v=event.target.value
      var value=v===false?0:v===true?1:v===''?null:v
      console.log(704,this.dow,this.dows)
      //var dow=this.dows.findIndex(d=>d==this.dow.codeId)+1
      var pload={"parameter":event.target.name,"value":value,"slotId":event.target.id,"dow":dow};
      //var pload={[event.target.name]:event.target.value};
      var action='saveItem';
      let payload={"action":action,"table":"AllParametersByDOW_single","payload":pload};
      console.log(307,payload)
      this.updateDB(payload)
    }, 1000), */
    showItem(i)
    {
      console.log(702,i)
      this.selectedItem=i;
      this.sumReviews=i.minimumScore;
      this.prize_hash=JSON.stringify(this.selectedItem);
    },  
    editItem(f=null)
    {
      if (f) 
      {
        this.editedItem=f;
      }
      else{
        this.editedItem={...this.emptyItem};
        this.editedItem.active=1;
      }
      console.log(214,f)
      this.hash=JSON.stringify(this.editedItem);
      this.dialog_edit=true;
    },
    deleteItem(f)
    {
      this.selectedItem=f;
      console.log(214,f)
      this.dialog_delete=true;
    },    
    async saveItem(a)
    {
        console.log(144,this.selectedItem);
        this.loading_update=true;
        console.log(255,this.form);
        var action='';
        switch(a)
        {
          case 'delete':
            action='deleteItem'
            this.selectedItem.active=0;
          break;
          case 'new':
            action='saveItem';
            this.selectedItem.prizeId=null;
            this.selectedItem.active=1;
          break;
          default:
            action='saveItem';
            this.selectedItem.active=1;
        }

        let payload={"action":action,"table":"User_Prizes","payload":JSON.stringify(this.selectedItem)};
        console.log(257,payload)
        let w= await this.updateDB(payload)
        this.loading_update=false;
        console.log(260,w);
        if(w.errorid=='0')
        {
            //this.snackbar_color="success"
            //this.message =w.payloads.message;
            this.snackbar = true;
            this.dialog_edit=false;
            this.dialog_delete=false;
            this.prize_hash=JSON.stringify(this.selectedItem);
            this.getData('refresh');
            //this.$root.$emit('onupdateLocations', null);
            //this.slotsByDOW_hash=JSON.stringify(this.slotsByDOW);
        }   
        //this.editedItem={...this.emptyItem}
    },
    async getData2()
    {
        {
            this.loading=true;
            try{
                const payload=JSON.stringify({"date": this.date,"action":"AllParameters_get"});
                const res = await this.$http.post('/settings/settings.php', payload );
                console.log(275,res);
                switch (res.data.errorid)
                {
                case '0':
                    sessionStorage.setItem('jwt', res.data.jwt);
                    this.loading= false;
                    this.allLocations=res.data.payloads.allLocations;
                    this.allMeals=res.data.payloads.allMeals,
                    this.activeSlots=res.data.payloads.activeSlots;
                    this.activeSlots_hash=JSON.stringify(this.activeSlots);
                    this.tabs=res.data.payloads.allLocations;
                    console.log(282,this.allSlots,this.tabs,this.activeSlots)
                break;
                case '0006':
                    this.$router.push('/auth/login').catch(() => {});
                break;
                }
                this.loading= false;
            } catch(e)
            {
                this.loading= false;
                //console.log(res.data);
            }
        }
    },     
    async getData(origin)
    {
        {
            if(origin=='refresh')
            {
              this.loading_refresh=true;
            }
            else
            {
              this.loading=true;
            }
            try{
                const payload=JSON.stringify({"action":"Prizes_iReview_get"});
                const res = await this.$http.post('/settings/settings.php', payload );
                console.log(275,res);
                this.loading_refresh=false;
                switch (res.data.errorid)
                {
                case '0':
                    sessionStorage.setItem('jwt', res.data.jwt);
                    this.prizes=res.data.payloads.allPrizes;
                    console.log(313,res.data.payloads.activeCoupon.activeCoupon)
                    this.selectedItem=this.prizes.find(p=>p.class==res.data.payloads.activeCoupon.activeCoupon)
                    this.prize_hash=JSON.stringify(this.selectedItem);
                    console.log(315,this.prizes)
                break;
                case '0006':
                    this.$router.push('/auth/login').catch(() => {});
                break;
                }
                this.loading= false;
            } catch(e)
            {
                this.loading= false;
                //console.log(res.data);
            }
        }
    },    
    async updateDB(payload){
        try{
            const res = await this.$http.post('/settings/settings.php', payload);
            console.log(383,res);
            if (res.data.errorid=='0')
            {
            sessionStorage.setItem('jwt', res.data.jwt);
            this.snackbar_color='success';
            this.snackbar_message=res.data.message;
            
            if (res.data.message)
            {
                console.log(392);
                this.snackbar=true;
            }
            }
            else
            {
              this.snackbar_color='error'
              this.snackbar_message=res.data.message;
              this.snackbar=true;
            console.log(401);
            //this.$router.push('/auth/login').catch(() => {});
            }

            //this.$store.dispatch("setUser", res.data.user); 
            return res.data;
        } catch(e)
        {
        console.log(e);
        }
    }
  },
};
</script>